<template>
	<div>
		<v-layout>
			<v-container>
				<v-layout row wrap>
					<v-flex xs12>
						<v-btn
							color="primary"
							dark
							@click="showExportMenu = true"
						>
							<v-icon>cloud_download</v-icon> &nbsp;
							{{ $t('workers.export_finance_report') }}
						</v-btn>
					</v-flex>
					<v-flex sm2 xs6>
						<SalaryDialog v-if="!permission"
							:prepayment="prepayment"
						/>
					</v-flex>
					<v-flex sm2 xs6>
						<PrePaymentDialog
							type="premium"
						/>
					</v-flex>
					<v-flex sm2 xs6>
						<PrePaymentDialog
							type="prepay"
						/>
					</v-flex>
					<v-flex sm2 xs6>
						<PrePaymentDialog
							type="accommodation"
						/>
					</v-flex>
					<v-flex sm2 xs6>
						<PrePaymentDialog
							type="fare"
						/>
					</v-flex>
					<v-flex sm2 xs6>
						<PrePaymentDialog
							type="zp"
						/>
					</v-flex>
				</v-layout>
				<v-layout :class="$vuetify.breakpoint.xs ? 'column' : 'row'">
					<v-flex xs6 md4>
						<Datepicker
							v-model="datesFinance.date_start"
							:label="$t('workers.date_start')"
						/>
					</v-flex>
					<v-flex xs6 md4>
						<Datepicker
							v-model="datesFinance.date_end"
							:label="$t('workers.date_end')"
						/>
					</v-flex>
					<v-flex md3 d-flex align-center>
						<v-btn @click="getFinance">{{$t('common.find')}}</v-btn>
					</v-flex>
				</v-layout>
			</v-container>
		</v-layout>
		<v-data-table
			:headers="headers"
			:items="finance"
			hide-actions
			class="elevation-1"
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.created_at }}</td>
				<td class="text-xs-left">{{ $t('payments_types.type_' + props.item.type) }}</td>
				<td>{{ props.item.user.name }}</td>
				<td class="text-xs-left">{{ props.item.amount }}</td>
				<td class="text-xs-left">{{ props.item.comment }}</td>
				<td class="text-xs-left">
					{{ props.item.hourly_rate ? props.item.hourly_rate + ' Kč' : '' }}
				</td>
				<td class="text-xs-left">
					{{ props.item.number_hours }}
				</td>
				<td class="text-xs-center">
					<span v-if="props.item.type == 'salary'"></span>
					<v-icon v-else-if="props.item.salary_id" :title="props.item.salary_id" large color="green darken-2">done</v-icon>
					<v-icon v-else large color="blue darken-4">remove</v-icon>
				</td>
				<td>
					<ConfirmDialog class="delete-confirm"
						v-if="!hasRole('canPrepay') || (hasRole('canPrepay') && props.item.owner)"
						v-bind="propConfirmDialog"
						@accept="onDeletePay(props.item.id)"
						:tooltip="$t('common.delete')"
					>
							<v-icon dark>delete</v-icon>
					</ConfirmDialog>
				</td>
			</template>
		</v-data-table>
		<export-menu
			v-model="showExportMenu"
			@export="exportPays" />
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { HEADERS_TABLE_FINANCE } from '../../../../constants'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import Datepicker from '../../../../components/DatePicker'
import SalaryDialog from './SalaryDialog'
import PrePaymentDialog from './PrePaymentDialog'
import DownloadExel from '../../../../components/DownloadExel'
import { localeHeadersWorkers } from '../../../../utils/helpers'
import { notify } from '../../../../utils/notifications'
import ExportMenu from '../../ExportMenu'
import * as moment from 'moment'

export default {
	components: {
		ConfirmDialog,
		Datepicker,
		SalaryDialog,
		PrePaymentDialog,
		DownloadExel,
		ExportMenu
	},
	data() {
		return {
			headers: localeHeadersWorkers(HEADERS_TABLE_FINANCE, this.$t),
			propConfirmDialog: {
				message: this.$t('workers.confirm_message_pay'),
				title: this.$t('common.confirm'),
				btnProps: {
					fab: true,
					dark: true,
					small: true,
					color: 'red lighten-2',
				}
			},
			showExportMenu: false
		}
	},
	computed: {
		...mapGetters({ hasRole: 'auth/hasRole' }),
		...mapState({
			finance: ({ workers }) => workers.finance,
			datesFinance: ({ workers }) => workers.datesFinance,
			financeFile: ({ workers }) => workers.financeFile,
			isDownloadReport: ({ workers }) => workers.isDownloadReport,
		}),
		prepayment() {
			return this.finance.reduce((acc, item) => {
				let sum = acc
				if (
					(item.type === 'prepay' ||
					 item.type === 'accommodation' ||
					 item.type === 'debt' ||
					 item.type === 'zp' ||
					 item.type === 'fare') &&
					 item.salary_id == null
				) sum += parseFloat(item.amount)
				return sum
			}, 0).toFixed(2)
		},
		permission() {
			return this.hasRole('canPrepay')
		}
	},
	created() {
		this.datesFinance.date_start = moment().subtract(2, 'months').startOf('month').format('DD.MM.YYYY')
		this.datesFinance.date_end = moment().endOf('month').format('DD.MM.YYYY')
	},
	methods: {
		...mapMutations({
			clearFile: 'workers/setFinanceFile'
		}),
		...mapActions({
			getFinance: 'workers/getFinance',
			exportWorkers: 'workers/exportWorkers',
			deletePay: 'workers/deletePay'
		}),
		exportPays (payData) {
			let query = {
				worker_id: this.$route.params.workerId,
				...payData
			}

			this.selectedAgency ? query.agency_id = this.selectedAgency.id : ''
			this.selectedEmployer ? query.employer_id = this.selectedEmployer.id : null,
			this.$route.query.search ? query.search = this.$route.query.search : null

			this.exportWorkers(query)
		},
		onDeletePay(id) {
			this.deletePay(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', { type: this.$t('workers.pay') }),
				})
				this.getFinance()
			})
		}
	}
}
</script>

<style>
.delete-confirm {
	width: 40px;
	float: right;
}
.finance-pay-button {
	width: 158px;
}
</style>
